var $5693e734f8e52053$exports = {};
const $5693e734f8e52053$var$Configuration = {
    apiUrl: "https://api.hint.com",
    apiVersion: "20261016141135",
    emrNotesUrl: "https://api.one.hint.com/notes",
    emrNotesVersion: undefined,
    emrNotesCsp: "https://api.one.hint.com/notes/",
    emrCalendarsUrl: "https://api.one.hint.com/calendars",
    emrCalendarsVersion: undefined,
    emrCalendarsCsp: "https://api.one.hint.com/calendars/",
    emrMessagingUrl: "https://api.one.hint.com/messaging",
    emrMessagingVersion: undefined,
    emrMessagingCsp: "https://api.one.hint.com/messaging/",
    env: "production",
    hintEnv: "production",
    fullStoryOrgId: "o-1T3FAV-na1",
    googleMapsKey: "AIzaSyC70wIphqbjFg2gjPjkVGEpwym3QTKxSb4",
    googleRecaptchaSiteKey: "6LfOL9gZAAAAADa1ZTyoPjOfwV9pQRXEMhAb9xRM",
    intercomAppId: undefined,
    newRelicAccountId: "1295351",
    newRelicLicenseKey: "f80caba954",
    newRelicApplicationId: "784027700",
    release: "b6f3f95b0366e12d5705fa6273001877e4a84239",
    sentryOrganizationId: "o4505133335904256",
    sentryProjectId: "4505286157729792",
    sentryKey: "558356d795f64c16a85cce356d98018c",
    sentryEnvironment: "production",
    sentryReleaseVersion: "b6f3f95b0366e12d5705fa6273001877e4a84239",
    stripePublishableKey: "pk_live_ImPWqYGkbMfjwg22MiAmB6u4",
    statuspageEmbedCode: "8mxj6zhmjmzp",
    emrChatAttachmentCsp: "https://*.s3.us-east-1.amazonaws.com",
    enableMeticulous: false
};
$5693e734f8e52053$exports = $5693e734f8e52053$var$Configuration;


window.CONFIGURATION = $5693e734f8e52053$exports;


//# sourceMappingURL=member-portal-elm.8808f56f.js.map
